import { FC, ReactNode } from 'react';
import { CardType } from "./types"
import {
    IconLock,
    IconInfoCircle,
    IconDownload,
    IconCheckbox,
    IconSquare
} from "@tabler/icons-react";

const Wrapper = ({ action, children, onClick, className }: { action: boolean, children: ReactNode, onClick: () => void, className?: string }) => {
    if (action) {
        return <button onClick={onClick} className={`duration-300 ${className}`}>{children}</button>
    }
    return <div className={className}>{children}</div>
}

// @ts-ignore
const List: FC<CardType> = ({
    unit,
    estado,
    idProject,
    toggleBidder,
    openDrop,
    setOpenDrop,
    dropdownRef,
    handleSelect,
    handleOpen
}) => {
    const { base_price, id, name, status } = unit;

    const pre_reserva = ["pre_booked"].includes(status);

    const reservado = ["taken", "assigned", "signing_promise"].includes(status)
    const accionReserva = pre_reserva || reservado;


    const assigned = status === "assigned";
    const created = ["created", "disabled"].includes(status);
    const available = status === "available";

    const pdf = false;

    const onActionReserva = () => {
        if (pre_reserva) {
            handleOpen(idProject, id)
        }
        if (reservado) {
            toggleBidder()
        }
    }

    const onAction = (state: string) => () => {
        handleSelect(state)
    }

    const onDownloadPDF = () => {
        window.alert("PDF")
    }

    return (
        <div className={`h-16 w-[200px] min-w-[200px] cursor-grab active:cursor-grabbing border border-black`}>
            <div className={`flex flex-row justify-between size-full select-none ${estado[status]?.class || ""} `}>
                <Wrapper onClick={onActionReserva} action={accionReserva as boolean} className='flex flex-col p-1 w-full flex-1'>
                    <div className='flex flex-row justify-between gap-2 h-[14px]'>
                        <div className='text-[9px] font-light'>{estado[status]?.name || ""}</div>
                    </div>
                    <div className='text-xs line-clamp-1 mb-1 text-left'>{name}</div>
                    <div className='flex flex-row justify-between items-end gap-2 mt-auto'>
                        <div className='flex-1 border-black/20 w-fit'>
                            {accionReserva && <IconInfoCircle className={`size-4 min-w-4 rounded-full ${estado[status]?.class}`} />}
                        </div>
                        <div className='text-base text-right leading-[1]'>{base_price}</div>
                    </div>
                </Wrapper>

                <div className='border-l border-black/20 w-[30px] h-full flex flex-col justify-around items-center flex-3'>
                    <div className='flex-1 flex flex-col justify-around items-center'>
                        {assigned &&
                            <button onClick={onAction("assigned")} title="Liberar unidad" >
                                <IconLock className={`size-4 hover:scale-[1.2] min-w-4 rounded-full ${estado[status]?.class}`} />
                            </button>
                        }
                        {created &&
                            <button onClick={onAction("created")} title="Habilitar unidad" >
                                <IconSquare className={`size-4 hover:scale-[1.2] min-w-4 rounded-full ${estado[status]?.class}`} />
                            </button>
                        }
                        {available &&
                            <button onClick={onAction("available")} title="Deshabilitar unidad" >
                                <IconCheckbox className={`size-4 hover:scale-[1.2] min-w-4 rounded-full ${estado[status]?.class}`} />
                            </button>
                        }
                    </div>
                    <div className='flex-1 flex flex-col justify-around items-center'>
                        {pdf &&
                            <button onClick={onDownloadPDF} title="Descargar PDF" >
                                <IconDownload className={`size-4 hover:scale-[1.2] min-w-4 rounded-full ${estado[status]?.class}`} />
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default List;
